import {ListSharedValueObject} from '../../shared/ValueObjects/ListSharedValueObject.js'
import {MakeSpecificationVehiclesValueObject} from './MakeSpecificationVehiclesValueObject.js'

export class ListMakesOptionsValueObject extends ListSharedValueObject {
  constructor({value}) {
    super({value})
  }

  static createFromApiResponse({items}) {
    this.validate({value: items})
    const makes = items.map(item => {
      return MakeSpecificationVehiclesValueObject.createFromLiteralsWithIcon({
        id: item.makeId,
        name: item.name
      })
    })

    return new ListMakesOptionsValueObject({value: makes})
  }

  getFilterOptions() {
    return this.value.map(make => {
      const {id, name} = make
      return {
        id,
        value: id,
        label: name
      }
    })
  }
}
